import './index.css';
import React, { startTransition } from "react";
import ReactDOM from "react-dom/client";
import "./styles/rtl.css";
import "./styles/mobile-enhancements.css";
import "./styles/motion.css";
import App from "./App";
import { installIntentPrefetch, prefetchForLocation } from "./utils/routePrefetch";

// Shop / product data starts now, in parallel with the page's code chunk.
prefetchForLocation(window.location);
installIntentPrefetch();

const root = ReactDOM.createRoot(document.getElementById("root"));
// The first render runs as a transition: React renders in slices and lets
// the browser breathe in between (input, network, image decoding) instead
// of one long task of several hundred ms on a slow phone. The page itself
// is the same; only the work is split.
startTransition(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// Offline support (public/sw.js): registered by a lazy chunk once the page has
// loaded and the browser is idle, so it never competes with the first paint.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator && !window.Capacitor) {
  const startSw = () => {
    const run = () => import('./utils/swRegister').then((mod) => mod.default()).catch(() => {});
    if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 10000 });
    else setTimeout(run, 3000);
  };
  if (document.readyState === 'complete') startSw();
  else window.addEventListener('load', startSw, { once: true });
}

// Push notifications exist only inside the Capacitor app shell (window.Capacitor);
// the website never downloads that code.
(async () => {
  if (!window.Capacitor) return;
  try {
    const mod = await import("./utils/pushNotifications");
    if (mod.isRunningInApp && mod.isRunningInApp()) {
      const token = localStorage.getItem("token");
      const userData = localStorage.getItem("user");
      if (token && userData) {
        const user = JSON.parse(userData);
        await mod.initPushNotifications(user.user_id);
      }
    }
  } catch (_) {}
})();